import { gql } from "@apollo/client"

export const GET_TEMPLATE = gql`
  query FormRequest(
    $staff_id: ID!
    $supervision_staff_membership_id: ID
    $organization_id: ID
    $enterprise_id: ID
    $participant_id: ID!
    $idTemplate: ID!
    $type: ID!
    $idStamp: ID
    $editMode: Boolean
    $retrieveLatestAssessment: Boolean
  ) {
    template(
      staff_id: $staff_id
      supervision_staff_membership_id: $supervision_staff_membership_id
      participant_id: $participant_id
      idTemplate: $idTemplate
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      type: $type
      idStamp: $idStamp
      editMode: $editMode
      retrieveLatestAssessment: $retrieveLatestAssessment
    ) {
      total_blocks
      template_availability
      template_description
      template_name
      template_title
      template_type
      template_category
      audit_type 
      values
      blocks {
        system_required
        idBlock
        block_name
        block_title
        total_fields
        index
      }
    }
  }
`

export const GET_ENTERPRISE_FIELD_DEFS = gql`
  query EnterpriseFieldDefs(
    $enterprise_id: ID
  ) {
    fieldDefs: fieldsByType(
      type: ["date", "time", "conditional_date", "conditional_time"]
      subtype: ["date", "time", "datetime"]
      enterprise_id: $enterprise_id
    ) {
      field_name
      field_type
      field_type_subtype
    }
  }
`

export const GET_TEMPLATE_AUDIT_TYPES = gql`
  query FormTemplateAuditTypes(
    $staff_id: String!
    $organization_id: ID
    $enterprise_id: ID
  ) {
    templates(
      type: "system"
      staff_id: $staff_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      idTemplate
      audit_type
    }
  }
`

export const GET_TEMPLATE_PAGE = gql`
  query FormPerPage(
    $staff_id: ID!
    $supervision_staff_membership_id: ID
    $organization_id: ID
    $enterprise_id: ID
    $participant_id: ID!
    $idTemplate: ID!
    $type: ID!
    $page: Int
    $idStamp: ID
    $editMode: Boolean
  ) {
    template(
      staff_id: $staff_id
      supervision_staff_membership_id: $supervision_staff_membership_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      participant_id: $participant_id
      idTemplate: $idTemplate
      type: $type
      page: $page
      idStamp: $idStamp
      editMode: $editMode
    ) {
      total_blocks
      template_description
      template_name
      template_title
      template_type
      audit_type
      blocks {
        idBlock
        block_name
        block_title
        index
        fields {
          idField
          field_type
          field_type_subtype
          field_description
          field_conditional
          field_label
          field_default_value
          field_name
          field_visibility
          read_only
          field_options {
            ...fieldOptions
          }
          field_validation {
            ...fieldValidation
          }
          multi_fields {
            ...multiField
            multi_fields {
              ...multiField
            }
          }
        }
        configuration {
          rules {
            assessments {
              assessment_id
              required
            }
          }
        }
      }
    }
  }
  fragment fieldOptions on TypeFieldOptions {
    label
    value
  }
  fragment fieldValidation on TypeFieldValidation {
    required
    number_min
    number_max
    force
    maxlength
    file_extension
    file_size
    file_multi_files
    file_firestore_storage
    file_cloud_storage
    file_is_shared
    file_is_renameable
  }
  fragment multiField on TypeMultiField {
    field_name
    field_type
    field_type_subtype
    field_label
    field_options {
      ...fieldOptions
    }
    field_validation {
      ...fieldValidation
    }
  }
`
